/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AccessWebAppModal from 'shared/ui/components/modals/AccessWebAppModal.vue';
import FpExtId from 'shared/ui/components/form-components/FpExtId.vue';

const __vue_script__ = {
    name: 'PersonPhoto',

    components: {
        FpExtId
    },

    props: {
        event: {
            type: Object,
            required: true,
        },

        userDoc: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            backgroundColor: 'black',
            color: 'white',
            imgSrc: undefined,
            ready: false,
            showInitials: false,
            dragging: false
        };
    },

    computed: {
        initials() {
            return this.$utils.pax.getInitials(this.userDoc);
        },

        fullName() {
            return this.$utils.pax.getFullName(this.userDoc);
        }
    },

    async mounted() {
        try {
            this.showInitials = await this.$services.settings.getSetting(this.event._id, 'person.show_initials');
            const theme = await this.$services.theme.getTheme(this.event._id);
            const backgroundColor = theme?.layouts?.navigation_bar?.background_color;
            const color = theme?.layouts?.navigation_bar?.title?.font_color;

            if (backgroundColor) {
                this.backgroundColor = backgroundColor;
            }

            if (color) {
                this.color = color;
            }

            this.setImage();

        } catch (error) {
            console.error('[PersonPhoto] could not load theme', error);
        } finally {
            this.ready = true;
        }
    },

    methods: {
        async setImage() {
            this.imgSrc = this.$utils.assets.getPaxPicture(this.event._id, this.userDoc._id) + '?_=' + new Date().getTime();
        },

        onPhotoError() {
            if (this.showInitials) {
                this.imgSrc = undefined;
            } else {
                this.imgSrc = this.$utils.assets.getEventAssetPath(this.event._id, 'icon.nophoto');
            }
        },

        async selectFile() {
            /** @returns {Promise<File|undefined>} */
            const getFile = () => new Promise(resolve => {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', this.$utils.assets.SUPPORTED_AVATAR_TYPES.join(','));
                input.addEventListener('change', e => {
                    const file = e.target.files[0];
                    return resolve(file);
                });
                input.click();
            });

            const file = await getFile();
            if (!file) { return; }

            await this.upload(file);
        },

        /**
         * Uploads a file asynchronously.
         *
         * @param {File} file - The file to be uploaded.
         * @returns {Promise<void>} A promise that resolves when the upload is complete.
         */
        async upload(file) {
            try {
                await this.$services.pax.uploadAvatar(this.event._id, this.event.node, this.userDoc, file);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('profile.messages.picture_uploaded').toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (err) {
                console.error('[PersonPhoto] could not upload photo', err);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('profile.messages.picture_uploaded_failure', [this.email]).toString(),
                    type: 'error',
                    duration: 15000
                });

            } finally {
                this.setImage();
            }
        },

        /**
         * Opens the Access Webapp Modal.
         */
        openAccessWebappModal() {
            this.$modal.show(AccessWebAppModal, {
                eid: this.event._id,
                pid: this.userDoc._id,
                fname: this.userDoc.fname,
            }, {
                classes: 'small',
                height: 'auto'
            });
        },

        /**
         * Opens the badge printing page.
         */
        openBadgePrintingPage() {
            const path = this.$services.pax.getBadgePrintingPath(
                this.event._id, this.userDoc.fp_ext_id,
            );

            this.$services.router.openNewWindow(path);
        },

        /**
         * Handles the drop event for a specific type.
         *
         * @param {Event} event - The drop event object.
         * @param {string} type - The type associated with the drop event.
         */
        onDrop(event) {
            this.dragging = false;
            event.preventDefault();
            const file = event.dataTransfer.files[0];

            console.info(file);
            if (!file) { return; }

            if (this.$utils.assets.SUPPORTED_AVATAR_TYPES.includes(file.type)) {
                this.upload(file);
            } else {
                const supported = this.$utils.assets.SUPPORTED_AVATAR_TYPES;
                const types = this.$utils.assets.humanReadableMime(supported);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('profile.messages.picture_unsupported', [types.join(', ')]).toString(),
                    type: 'error',
                    duration: 15000
                });
            }

        }
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        {
          staticClass: "person-photo boxed-content",
          class: { dragging: _vm.dragging },
          on: {
            drop: _vm.onDrop,
            dragover: function ($event) {
              $event.preventDefault()
              _vm.dragging = true
            },
            dragenter: function ($event) {
              $event.preventDefault()
              _vm.dragging = true
            },
            dragleave: function ($event) {
              $event.preventDefault()
              _vm.dragging = false
            },
          },
        },
        [
          _c("div", { staticClass: "picture" }, [
            _vm.imgSrc
              ? _c("img", {
                  attrs: { src: _vm.imgSrc, title: _vm.fullName },
                  on: { error: _vm.onPhotoError },
                })
              : _c("svg", { attrs: { viewBox: "0 0 10 10" } }, [
                  _c("title", [_vm._v(_vm._s(_vm.fullName))]),
                  _c("circle", {
                    attrs: {
                      cx: "5",
                      cy: "5",
                      r: "4.8",
                      fill: _vm.backgroundColor,
                      stroke: _vm.color,
                      "stroke-width": ".1",
                    },
                  }),
                  _c(
                    "text",
                    {
                      attrs: {
                        x: "5",
                        y: "6.5",
                        "text-anchor": "middle",
                        "font-size": "4",
                        fill: _vm.color,
                      },
                    },
                    [_vm._v(_vm._s(_vm.initials))]
                  ),
                ]),
            _c("div", { staticClass: "photo-controls" }, [
              _vm.imgSrc && _vm.showInitials
                ? _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: { click: _vm.selectFile },
                    },
                    [_vm._v(_vm._s(_vm.$t("user_display.replace")))]
                  )
                : _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: { click: _vm.selectFile },
                    },
                    [_vm._v(_vm._s(_vm.$t("user_display.upload_photo")))]
                  ),
            ]),
          ]),
          _c("div", { staticClass: "actions" }, [
            _c(
              "button",
              {
                staticClass: "btn important",
                class: { "btn-primary": _vm.dragging },
                attrs: { type: "button" },
                on: { click: _vm.openAccessWebappModal },
              },
              [
                _c("i", { staticClass: "ic-feed" }),
                _vm._v(
                  _vm._s(
                    _vm.$t("user_display.access_webapp_as", [_vm.userDoc.fname])
                  )
                ),
              ]
            ),
            _vm.$services.blueprint.isModuleInstalled("badger")
              ? _c(
                  "button",
                  {
                    staticClass: "btn important",
                    class: { "btn-primary": _vm.dragging },
                    attrs: { type: "button" },
                    on: { click: _vm.openBadgePrintingPage },
                  },
                  [
                    _c("i", { staticClass: "ic-badge" }),
                    _vm._v(
                      _vm._s(
                        _vm.$t("user_display.prepare_badge_print_for", [
                          _vm.userDoc.fname,
                        ])
                      )
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _c("fp-ext-id", { attrs: { doc: _vm.userDoc } }),
          _vm.userDoc.unsubscribed_from_emails
            ? _c("div", { staticClass: "unsubscribed" }, [
                _c("div", { staticClass: "alert alert-info" }, [
                  _c(
                    "p",
                    [
                      _vm._v(_vm._s(_vm.$t("user_display.emails.unsub"))),
                      _vm.userDoc.unsubscribed_at
                        ? [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("user_display.emails.unsub_on")
                                  ) +
                                  ":"
                              ),
                            ]),
                            _c("br"),
                            _c("strong", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$utils.time.tsToFormat(
                                      _vm.userDoc.unsubscribed_at,
                                      "LLLL"
                                    )
                                  )
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/fp-type-display/PersonPhoto.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__